import React from "react";
import { useNavigate } from "react-router-dom";
import SmartFiltersWizard from "./SmartFiltersWizard";

const SmartFiltersPage: React.FC = () => {
  const navigate = useNavigate();

  const handleComplete = () => {
    // Navigate back to the alert profiles list
    navigate("/alerts");
  };

  return <SmartFiltersWizard onComplete={handleComplete} />;
};

export default SmartFiltersPage;
